import {
  CANCEL_PAYMENT_SCHEDULE_LOADING,
  CANCEL_PAYMENT_SCHEDULE_SUCCESS,
  CANCEL_PAYMENT_SCHEDULE_FAILED,
} from "../types";

interface CancelPaymentScheduleState {
  loading: boolean;
  data: any;
  error: string | null;
}

const initialState: CancelPaymentScheduleState = {
  loading: false,
  data: null,
  error: null,
};

const cancelPaymentScheduleReducer = (
  state = initialState,
  action: any
): CancelPaymentScheduleState => {
  switch (action.type) {
    case CANCEL_PAYMENT_SCHEDULE_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case CANCEL_PAYMENT_SCHEDULE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case CANCEL_PAYMENT_SCHEDULE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default cancelPaymentScheduleReducer;

